module.exports = __webpack_public_path__ + "img/vip-y.bed1c414.png";